import {
  ButtonBase,
  Grid,
  Theme,
  Typography,
  makeStyles,
} from '@material-ui/core';
import { InstructionsLayout, colors } from 'design-system';
import { useState } from 'react';
import { HelpCircle } from 'react-feather';

const useStyles = makeStyles((theme: Theme) => ({
  instructionsWrapper: {
    marginLeft: theme.spacing(1),
    marginTop: theme.spacing(-1),
    marginBottom: theme.spacing(1),
    textAlign: 'center',
  },
  customButtonText: {
    color: colors.bright_turquoise,
    fontSize: 14,
    fontWeight: 600,
    lineHeight: '19px',
    marginRight: 10,
  },
}));

type Props = {
  showHelp: boolean;
};

const DriverIdentificationHelper = ({ showHelp }: Props): JSX.Element => {
  const classes = useStyles();
  const [instructionsVisible, toggleInstructionsVisible] =
    useState<boolean>(false);
  return (
    <>
      <InstructionsLayout
        id="finalbeneficiary"
        data-testid="instruction-modal"
        open={instructionsVisible}
        headerTitle="¿Cómo ingresar tu cédula?"
        title="Número de cédula"
        content={
          <img
            id="sales-web-identification-instruction"
            alt="cedula"
            src="/svg/id_format_guide.svg"
          />
        }
        instructions={
          <Typography
            id="sales-web-identification-text"
            variant="body2"
            align="center"
            style={{ color: colors.abbey }}
          >
            Escribe tu número de cédula, como aparece en ella, sin espacios ni
            guiones.
          </Typography>
        }
        onCloseRequested={(): void => toggleInstructionsVisible(false)}
      />
      <Grid item xs={12} className={classes.instructionsWrapper}>
        {showHelp && (
          <ButtonBase
            id="sales-web-show-identification-button"
            data-testid="instructions-button"
            disableRipple
            onClick={(): void => toggleInstructionsVisible(true)}
          >
            <Grid container alignItems="center" justifyContent="center">
              <Typography className={classes.customButtonText}>
                CÓMO DEBES INGRESAR TU CÉDULA
              </Typography>
              &nbsp;
              <HelpCircle color={colors.bright_turquoise} />
            </Grid>
          </ButtonBase>
        )}
      </Grid>
    </>
  );
};

export default DriverIdentificationHelper;
